
// / thumbnails like an avito ////////////////////////////////////////////////////////////////////////

let imgTabs;
$(".img-subs").each(function() {
  imgTabs ='';
  // console.log($(this).children('.img-sub'));
  
  if ($(this).children('.img-sub').length === 1){
      imgTabs += `<a class="img-tab img-tab-alone" href="${$(this).find('.img-sub').data('src')}" data-fancybox="${$(this).data('id')}" ></a>`;
      // console.log($(this));
  }
  if ($(this).children('.img-sub').length > 1){

    $(this).children('.img-sub').each(function(i) {

      if ( i> 3) {
        
        imgTabs += `<a class="img-tab-empty" href="${$(this).data('src')}" data-fancybox="${$(this).parent('.img-subs').data('id')}" ></a>        `;
      }else{
        imgTabs += `<a class="img-tab" href="${$(this).data('src')}" data-fancybox="${$(this).parent('.img-subs').data('id')}" ></a>`;
      }
      
    });
  }
  
 $(this).parent().find('.img-tabs').html(imgTabs);
});



$(document).on({
    mouseenter () {
      $('.img-sub').removeClass('active');
      $(`.img-sub[data-src="${$(this).attr('href')}"]`).addClass('active');

      if (($(`.img-sub[data-src="${$(this).attr('href')}"]`).siblings().length > 3)&&($(`.img-sub[data-src="${$(this).attr('href')}"]`).index() === 3)){
        $(`.img-sub[data-src="${$(this).attr('href')}"]`).parent().addClass('more-images');
      }
    },
    mouseleave () {
        $('.img-sub').removeClass('active');
        $('.img-subs').removeClass('more-images');
    }
}, ".img-tab"); // pass the element as an argument to .on


$(document).on({
    mouseenter () {
      $(this).addClass('active');
      
    },
    mouseleave () {
        $(this).removeClass('active');
    }
}, ".img-tabs"); // pass the element as an argument to .on

// eof / thumbnails like an avito ////////////////////////////////////////////////////////////////////////